export const ArchiveTestIds = {
  buttonCancelArchiveroom: 'button_cancel_archiveroom',
  buttonConfirmArchiveroom: 'button_confirm_archiveroom',
  dialogContentArchiveroom: 'dialog_content_archiveroom',
  dialogActionsArchiveroom: 'dialog_actions_archiveroom'
} as const;
